module.exports = __webpack_public_path__ + "static/media/pat.43706eca.jpg";